<script setup>
const props = defineProps({
  jobEventData: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    required: true,
    validator: (value) => ["event", "job"].includes(value),
  },
});
const { globalData } = useTTCState();
const data = ref(globalData.value.footer);
const menu = ref(globalData.value.mainMenu);

const currentTheme = ref(null);
const route = useRoute();
onMounted(() => {
  const { getCurrentTheme } = useTheme();
  currentTheme.value = getCurrentTheme();
});

const footer = ref(null);
</script>

<template>
  <footer class="footer relative" ref="footer" data-section-theme="dark">
    <div
      class="footer-bg absolute left-0 top-0 z-[-1] h-full w-screen bg-light-grey"
      v-if="jobEventData.length > 0"
    ></div>
    <div
      class="lists-wrapper pb-[90px] pt-spacing-section md:pb-spacing-section-desktop md:pt-spacing-section-desktop"
      v-if="jobEventData.length > 0"
    >
      <div class="jobs-list" v-if="type === 'job'">
        <section-job-list
          heading="Other positions"
          :items="jobEventData"
          class="text-dark-grey"
        />
      </div>
      <div class="events-list" v-if="type === 'event'">
        <ui-bleed>
          <ui-font-text type="l" class="mb-10 text-dark-grey">
            Latest events
          </ui-font-text>
          <component-element-event-list
            class="text-dark-grey"
            :events="jobEventData"
          />
        </ui-bleed>
      </div>
    </div>
    <div
      :class="[
        `mx-bleed my-bleed grid gap-4 p-6 transition-colors duration-300 md:grid-cols-2`,
        jobEventData.length > 0
          ? `bg-light-grey-2 text-dark-grey`
          : `bg-${currentTheme} text-${currentTheme}-text`,
      ]"
    >
      <ul class="grid grid-cols-1 gap-3 text-xs">
        <li
          v-for="item in menu.data"
          :key="item.id"
          :class="item.level == 1 ? 'text-s font-bold' : ''"
        >
          <nuxt-link :to="item.url">{{ item.title }}</nuxt-link>
        </li>
      </ul>
      <div class="flex flex-col justify-between">
        <div class="grid items-start justify-start md:grid-cols-2">
          <div class="mt-10 grid grid-cols-1 gap-3 md:mt-0">
            <h3 class="text-s font-bold">{{ data?.contact.heading }}</h3>
            <ul
              class="grid grid-cols-1 gap-3 text-xs"
              v-for="address in data?.contact.addresses"
              :key="address.id"
            >
              <a :href="data?.contact.emailLink">{{
                data?.contact.emailLabel
              }}</a>
              <a :href="data?.contact.linkedInUrl">LinkedIn</a>
              <a :href="data?.contact.phoneNumberLink">{{
                data?.contact.phoneNumberLabel
              }}</a>
              <li>
                {{ address.addressLine1 }}, {{ address.postalCode }}
                {{ address.locality }}
              </li>
            </ul>
          </div>

          <div class="mt-10 grid grid-cols-1 gap-3 md:mt-0">
            <h3 class="text-s font-bold">{{ data.legal.heading }}</h3>
            <ul class="grid grid-cols-1 gap-3 text-xs">
              <li v-for="(item, idx) in data.legal.links" :key="item.id">
                <nuxt-link :to="item.url">{{ item.title }}</nuxt-link>
              </li>
            </ul>
            <span class="text-xs">{{ data.legal.copyright }}</span>
          </div>
        </div>
        <div class="mt-20 flex flex-col items-end justify-end">
          <globals-logo />
          <span class="mt-4 text-xs">Powered by Implement</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.jobs-list:deep(.address) {
  color: var(--dark-grey-1);
}

.jobs-list:deep(.job-card) {
  background-color: var(--light-grey);
}
.jobs-list:deep(.job-card:hover) {
  background-color: var(--light-grey-1);
}
.job-list:deep(.tag-corners-border) {
  --c: var(--dark-grey);
}
.events-list:deep(.tag-corners-border) {
  --c: var(--dark-grey);
}
.events-list:deep(.date) {
  color: var(--dark-grey);
}
.events-list:deep(.date) {
  color: var(--dark-grey);
}
.events-list:deep(.where) {
  color: var(--dark-grey-1);
}
.events-list:deep(.time) {
  color: var(--dark-grey);
}
.events-list:deep(.event-card) {
  background-color: var(--light-grey);
}
.events-list:deep(.event-card:hover) {
  background-color: var(--light-grey-1);
}
</style>
